// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["kofi-panel/style-index"], () => (__webpack_require__("./block-src/kofi-panel/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
